<template>
    <v-sheet style="background-color:#fff;height:100%">
        <v-toolbar floating elevation="0" style="border-bottom:1px solid #ddd" pb-5>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              
               <v-menu
                          v-model="menu_de_data"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                              v-model="de_data"
                              label="Início"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              style="width:150px"
                              class="pt-5"
                            ></v-text-field>
                          </template>
                          <v-date-picker :max="max_data" v-model="de_data" @input="menu_de_data = false"></v-date-picker>
                        </v-menu>

                <v-menu
                          v-model="menu_para_data"
                          :close-on-content-click="false"
                          :nudge-right="40"
                          transition="scale-transition"
                          offset-y
                          min-width="290px"
                        >
                          <template v-slot:activator="{ on }">
                            <v-text-field
                            class="pt-5"
                              v-model="para_data"
                              label="Fim"
                              prepend-icon="event"
                              readonly
                              v-on="on"
                              style="width:150px"
                            ></v-text-field>
                          </template>
                          <v-date-picker :max="max_data" v-model="para_data" @input="menu_para_data = false"></v-date-picker>
                        </v-menu>

              <v-btn @click="load_data()"  text color="primary"> <v-icon>search</v-icon></v-btn>



            </v-toolbar-items>
            
        </v-toolbar>

        <v-container fill-height fluid >
          <v-flex xs12 md12>
                  <v-layout>
                    <v-spacer></v-spacer>
                    <!-- DE -->
                    <v-flex xs4 md4>
                      <div class="">

                        
                      </div>
                    </v-flex>
                    <!-- DE -->
                    <v-flex xs4 md4>
                      <div class="">

                        
                      </div>
                    </v-flex>
                    <v-flex xs4 md1 align-self-center pl-5>
                        
                    </v-flex>
                  </v-layout>
                  
                </v-flex>

            <v-layout wrap v-if="seriesDiario.length == 0">
                <v-flex xs12>
                    <v-layout text-center align-center justify-center style="height:100%">
                        <v-flex xs12>
                            <h1 class="display-1 mb-5">
                                Ainda não há dados suficientes para criar
                                <br />os seus Insights
                            </h1>
                            <p class="subheading font-weight-regular my-5">
                                As informações sobre performance do seu conteúdo aparecerão aqui assim que os
                                <br />dados forem disponibilizados.
                            </p>
                        </v-flex>
                    </v-layout>
                </v-flex>
            </v-layout>

              <v-layout wrap v-if="seriesDiario.length != 0" mb-5 pb-5>
                
                <v-flex xs12 md12>
                 <h2 :class="['text-h2']" class="transition-swing " v-text="'Spotify Diário'"></h2>
                </v-flex>

                <v-flex xs12 md12>
                  <v-card elevation="0" class="px-5 py-5 border">
                    <apexchart type="area" height="350" :options="chartOptionsLineDiario" :series="seriesDiario"></apexchart>
                  </v-card >
                </v-flex>
                <v-flex xs12 md12>
                  <v-divider></v-divider>
                   <div class="display-1 text-left my-5">Tops</div>
                </v-flex>

                <v-flex xs12 md6 pr-1>
                  <v-data-table
                      :headers="topFaixas.headers"
                      :items="topFaixas.items"
                      :options="topFaixas.pagination"
                      class="elevation-0 border"
                    >
                     
                    </v-data-table>
                </v-flex>
                <v-flex xs12  md6 pl-1>
                  <v-data-table
                      :headers="topAlbums.headers"
                      :items="topAlbums.items"
                      :options="topAlbums.pagination"
                      class="elevation-0 border"
                    >
                     
                    </v-data-table>
                </v-flex>
                <v-flex xs12 md12>
                  <v-divider></v-divider>
                  <div class="display-1 text-left my-5">Audiência</div>
                </v-flex>
                 <v-flex xs12 md6 pr-1>
                     <v-card elevation="0" class="border">
                       <v-card-text>Faixa etária</v-card-text>
                    <apexchart type="bar" height="350"  :options="chartOptionsIdades" :series="seriesIdade"></apexchart>
                     </v-card> 
                 </v-flex>

                <v-flex xs12 md6 >
                  <v-card elevation="0" class="border " >
                    <v-card-text>Gêneros</v-card-text>
                      <apexchart type="pie" height="350" width="500" :options="chartOptionsGeneros" :series="seriesGenero"></apexchart>
                    </v-card> 
                </v-flex>

              </v-layout>
        </v-container>
    </v-sheet>
</template>

<style scoped>
.border{ border:1px solid #ddd}
</style>

<script>
import axios from "axios";
import VueApexCharts from "vue-apexcharts";

export default {
    data: () => ({
      //date picker
        menu_de_data:false,
        de_data: "",
        menu_para_data:false,
        para_data: "",
        max_data:"",
        //
        activeBtn: 1,
        raw_data: null,
        seriesDiario: [],
        seriesIdade: [],
        seriesGenero: [],
        chartOptionsLineDiario: {
          chart:{
            zoom:{ enabled: false}
          },
            dataLabels: {enabled: false},
            stroke: {curve: "straight"},
            title: {text: "", align: "left"}, 
            grid: {row: {colors: ["#fafafa", "transparent"], opacity: 0.5}},
            xaxis: { type:'datetime', categories:[] },
            
        },
        chartOptionsGeneros:{
            chart: {
              width: 380,
              type: 'pie',
            },
            labels: [],
            responsive: [{breakpoint: 480,options: {chart: {width: 200},legend: {position: 'bottom'}}}]
        },
       chartOptionsIdades: {
            plotOptions: {bar: {dataLabels: {position: 'bottom'},}},
            dataLabels: {
              enabled: true,
              formatter: function (val) {
                return val + "";
              },
              offsetY: -20,
              style: {
                fontSize: '16px',
                colors: ["#000"]
              }
            },
            
            xaxis: {
              categories: [],
              position: 'top',
              labels: {
                offsetY: -18,
            
              },
              axisBorder: {
                show: false
              },
              axisTicks: {
                show: false
              },
              crosshairs: {
                fill: {
                  type: 'gradient',
                  gradient: {
                    colorFrom: '#FFA726',
                    colorTo: '#BED1E6',
                    stops: [0, 100],
                    opacityFrom: 0.4,
                    opacityTo: 0.5,
                  }
                }
              },
              tooltip: {
                enabled: true,
                offsetY: -35,
            
              }
            },
            fill: {
              gradient: {
                shade: 'light',
                type: "horizontal",
                shadeIntensity: 0.25,
                gradientToColors: undefined,
                inverseColors: true,
                opacityFrom: 1,
                opacityTo: 1,
                stops: [50, 0, 100, 100]
              },
            },
            yaxis: {
              axisBorder: {
                show: true
              },
              axisTicks: {
                show: false,
              },
              labels: {
                show: false,
                formatter: function (val) {
                  return val + "";
                }
              }
            
            },
            title: {
              text: '',
              floating: true,
              offsetY: 320,
              align: 'center',
              style: {
                color: '#444'
              }
            }
          },
        topFaixas:
        {
          headers:[
            {text:'Faixa', value:'track_name'},
            {text:'ISRC', value:'isrc'},
            {text:'Álbum', value:'album_name'},
            {text:'Plays', value:'total_plays'}
          ],
          items:[],
          pagination: {
            sortBy: ['total_plays'],
            sortDesc:[true]
          }        
        },
        topAlbums:{
          headers:[
            {text:'Álbum', value:'name'},
            {text:'Código de Barras', value:'UPC'},            
            {text:'Plays', value:'total_plays'}
          ],
          items:[],
          pagination: {
            sortBy: ['total_plays'],
            sortDesc:[true]
          }        
        }
        
    }),
    components: {
        apexchart: VueApexCharts
    },
    created: function() {
      var today = new Date();
      var _date_d = new Date(new Date().setDate(today.getDate() - 30));
      var _date_p = new Date(new Date().setDate(today.getDate() - 2));

      this.de_data =  _date_d.toISOString().substr(0, 10)
      this.para_data =  _date_p.toISOString().substr(0, 10)
      this.max_data = this.para_data;
      //recarrega os dados
      this.load_data();

    },
    watch:{
      chartOptionsLineDiario:{
        handler: function(){
          //console.log('chartOptions alterado')
          //console.log(this.chartOptionsLineDiario);
        },
        deep:true
      },
      seriesDiario:{
        handler: function(){
          //console.log('alterado')
        },
        deep:true
      }
    },
    methods: {
        load_data(){
            this.$store.commit("loading");  
            //console.log(this.de_data);
            var artist_id = this.$store.getters.user.artists[0].id;
            axios
                .get(
                    `https://us-central1-pacato-mk.cloudfunctions.net/artistinsights?artist_id=${artist_id}&date_start=${this.de_data}&date_end=${this.para_data}`
                )
                .then(dados => {
                    
                    if (dados.status == 200) {
                        this.raw_data = dados.data;
                        this.generate_compiled_by_day();
                    }
                    this.$store.commit("loading", false); 
                }).finally(()=>{
                  this.$store.commit("loading", false); 
                });
        },

        generate_compiled_by_day() {
            let dias = [];
            var indices = [];
            var faixas = {};
            var albums = {};
            var idades = {};
            var generos = {}

            for (var dia in this.raw_data) {
              
                let _d = dia.substring(6)+"/"+dia.substring(4,6)
                let _d_data = dia.substring(0,4)+"-"+dia.substring(4,6)+"-"+dia.substring(6);
                indices.push(_d_data)
                dias.push( this.raw_data[dia].total_plays )
                //FAIXAS
                let _faixas_db = this.raw_data[dia].faixas
                for( var _faixa in _faixas_db){
                    let fkeys = Object.keys(faixas);
                    let isrc = _faixas_db[ _faixa ].isrc
                    if( fkeys.indexOf(isrc) >=0 ){
                      faixas[isrc].total_plays += _faixas_db[_faixa].total_plays
                    }else{
                      faixas[isrc] = _faixas_db[_faixa]
                      //window.console.log(faixas[_faixa])
                    }
                }

                //ALBUM
                let _produtos_db = this.raw_data[dia].produtos
                for( var _produto in _produtos_db){
                    let fkeys = Object.keys(albums);
                    let upc = _produtos_db[ _produto ].upc
                    if( fkeys.indexOf(upc) >=0 ){
                      albums[upc].total_plays += _produtos_db[_produto].total_plays
                    }else{
                      albums[upc] = _produtos_db[_produto]                      
                    }
                }

                //IDADE
                let _idades_db = this.raw_data[dia].idades
                for( var _idade in _idades_db){
                    let fkeys = Object.keys(idades);                    
                    
                    if( fkeys.indexOf(_idade) >=0 ){
                      idades[_idade] += _idades_db[_idade]
                    }else{
                      idades[_idade] = _idades_db[_idade]                    
                    }
                }

                //genero
               
                let _generos_db = this.raw_data[dia].generos
                for( var _genero in _generos_db){
                    let fkeys = Object.keys(generos);                    
                    
                    if( fkeys.indexOf(_genero) >=0 ){
                      generos[_genero] += _generos_db[_genero]
                    }else{
                      generos[_genero] = _generos_db[_genero]                    
                    }
                }

            }
            
           
            this.topFaixas.items = Object.keys(faixas).map(e=>{
              return faixas[e];
            });

             this.topAlbums.items = Object.keys(albums).map(e=>{
              return albums[e];
            })

            let ordered = {}
            Object.keys(idades).sort().forEach(function(key) {
              ordered[key] = idades[key];
            })
            this.chartOptionsIdades = {...this.chartOptionsIdades, ...{
              xaxis:{
                categories : Object.keys(ordered)
              }
            }}
            //.xaxis.categories = Object.keys(ordered);
            this.seriesIdade = [{ name:'Plays', data:Object.values(ordered)}];
            //this.seriesIdade.push( )
            let generos_labels = Object.keys(generos);            
            var ee = "";
            for(ee in generos_labels){              
              var name = generos_labels[ee].replace('female','feminino').replace('male','masculino').replace('unknown','não especificado')
              generos[name] = generos[generos_labels[ee]];
              delete generos[generos_labels[ee]]
            }
            this.chartOptionsGeneros.labels = Object.keys(generos);

            this.seriesGenero = this.chartOptionsGeneros.labels.map(function(e){
              return generos[e];
            });
            
            //console.log( dias )
            
            //this.$refs.chartDiario.updateSeries([{
            //  seriesDiario
            //}], false, true)

            
            //this.seriesDiario = [];
            this.seriesDiario = [ { 
              name: "Plays",
              data: dias
            }];
            this.chartOptionsLineDiario = {...this.chartOptionsLineDiario, ...{
              xaxis:{
                type:'datetime',
                categories: indices
              }
            }}
             //this.$forceUpdate(); 
        }
    }
};
</script>
